// src/services/MatchService.ts
import axios from "axios";

const BASE = "https://v3.football.api-sports.io";

const client = (key) =>
  axios.create({
    baseURL: BASE,
    headers: {
      "X-APISports-Key": key,
    },
  });

export async function getFixtureById({ key, fixtureId }) {
  // params: { id }
  const { data } = await client(key).get("/fixtures?id=" + fixtureId);
  return data?.response?.[0] ?? null;
}

export async function getFixtureEvents({ key, params }) {
  // params: { fixture }
  const { data } = await client(key).get("/fixtures/events", { params });
  return data?.response ?? [];
}

export async function getFixtureLineups({ key, params }) {
  // params: { fixture }
  const { data } = await client(key).get("/fixtures/lineups", { params });
  return data?.response ?? [];
}

export async function getFixtureStatistics({ key, params }) {
  // params: { fixture }
  const { data } = await client(key).get("/fixtures/statistics", { params });
  return data?.response ?? [];
}

export async function getStandings({ key, params }) {
  // params: { league, season }
  const { data } = await client(key).get("/standings", { params });
  // API returns nested list; flatten to table rows
  const list = data?.response?.[0]?.league?.standings?.[0] ?? [];
  return list;
}

export async function getHeadToHead({ key, params }) {
  // params: { h2h: "teamId1-teamId2", last? }
  // API path:
  const { data } = await client(key).get("/fixtures/headtohead", { params });
  return data?.response ?? [];
}
